// Font — Heebo weights used across the Studio design
import "@fontsource/heebo/400.css";
import "@fontsource/heebo/500.css";
import "@fontsource/heebo/600.css";
import "@fontsource/heebo/700.css";

// Design tokens (must come before global.css so theme vars are defined first)
import "./ui/tokens.css";
import "./styles/global.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { initTheme } from "./ui/theme";
import { LangProvider } from "./i18n";

// Apply theme immediately — sets data-theme on <html> before first paint.
// (The no-flash inline script in index.html also does this, but calling
//  initTheme() here keeps the React side in sync with any SSR-less hydration.)
initTheme();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LangProvider>
        <App />
      </LangProvider>
    </BrowserRouter>
  </React.StrictMode>
);
